import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { CustomDefaultBackdrop } from "./components/backdrop/default/v1";
import HomePage from "./pages/home";
import Inbound_RegisterPage from "./pages/inbound/register";
import Inbound_In_ProgressPage from "./pages/inbound/in-progress";
import Inbound_Scan_CompletedPage from "./pages/inbound/scan-completed";
import Inbound_CompletedPage from "./pages/inbound/completed";
import Inbound_Palette from "./pages/inbound/palette";
import Inbound_RackLocation from "./pages/inbound/rack-location";
import Inbound_PaletteInfo from "./pages/inbound/pallet-info";
import Inbound_Stage from './pages/inbound/stage';
import RackLocationBackupPage from "./pages/rack-location-backup";

function App() {
	return (
		<>
			<BrowserRouter>
				<CustomDefaultBackdrop />
				<AppCore />
			</BrowserRouter>
		</>
	);
}

function AppCore() {
	return (
		<Routes>
			<Route path='/' element={<HomePage />} />
			<Route path='/inbound/register' element={<Inbound_RegisterPage />} />
			<Route path='/inbound/in-progress' element={<Inbound_In_ProgressPage />} />
			<Route path='/inbound/pallet-info' element={<Inbound_PaletteInfo />} />
			<Route path='/inbound/scan-completed' element={<Inbound_Scan_CompletedPage />} />
			<Route path='/inbound/completed' element={<Inbound_CompletedPage />} />
			<Route path='/inbound/palette' element={<Inbound_Palette />} />
			<Route path='/inbound/rack-location' element={<Inbound_RackLocation />} />
			<Route path='/inbound/stage' element={<Inbound_Stage />} />
			<Route path='/rack-location-backup' element={<RackLocationBackupPage />} />
		</Routes>
	);
}

export default App;
